const TipoCadastroMedicoAssistenteOptions = [
  {
    id: 11,
    text: "Médico Assistente Equipe Clínico / Cirúrgico",
    value: "MedicoAssistenteEquipeCliECirur",
  },
  {
    id: 12,
    text: "Médico Assistente Equipe de Retaguarda",
    value: "MedicoAssistenteEquipeRetaguarda",
  },
];

export { TipoCadastroMedicoAssistenteOptions };
